export const siteSettings = {
  name: "Edge Tradex",
  link: "https://edgetradex.net",
  email: "support@edgetradex.net",
  appLink: "https://app.edgetradex.net",
};
